export default __webpack_public_path__ + "static/media/logo1.826c5b73.png";